<div class="card">
    <div class="card-header">
        Branch Geo Mapping
    </div>
    <div class="card-body">
        <div class="row m-1">
            <div class="col-md-5 px-1">
                <label class="Label">Branch</label>
                <ng-select name="branch" [items]="BranchMaster" bindLabel="BranchName" bindValue="BranchMasterID"
                    [(ngModel)]="BranchId" (change)=" onSelectChange('Branch');" placeholder="Select Branch">
                    <ng-option *ngFor="let segment of BranchMaster" [value]="segment.BranchMasterID">
                        {{ segment.BranchName }}
                    </ng-option>
                </ng-select>
            </div>
            <div class="col-md-3 px-1"><br>
                <button class="btn btn-sm btn-primary" name="submit" (click)="add()">
                    <i class="bi bi-download" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Load':'Loading...'}}
                </button>
            </div>
        </div>
        <div class="card border-radius-0 mt-1 p-0">
            <div class="card-body p-1" style="overflow: auto;">
                <table datatable [dtOptions]="this.dtoptions" [dtTrigger]="dtTrigger"
                    class="customeDatatable table table-bordered">
                    <thead>
                        <tr>
                            <th scope="col">#</th>
                            <th scope="col">
                                <input mdbCheckbox class="form-check-input" style="height: 15px; width: 15px;"
                                    name="header" type="checkbox" (change)="toggleSelectAllRows()"
                                    [checked]="selectAllRows" value="" />
                            </th>

                            <th scope="col" style="display: none; ">Branch ID</th>
                            <th scope="col" style="width: 130px;">Branch Name</th>
                            <th scope="col">Latitude</th>
                            <th scope="col">Longitude </th>
                            <th scope="col" style="width: 130px;">Radius (meter)</th>
                            <th scope="col">IsAltitudeApplicable</th>
                            <th scope="col" style="width: 150px;">Altitude (feet) </th>
                            <th scope="col" style="width: 150px;">Altitude Radius (feet) </th>
                            <th scope="col" style="width: 150px;">Accuracy</th>
                            <th scope="col">Heading</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let shift of BranchGeoMapping; let i = index">
                            <th scope="row">{{ i + 1 }}</th>
                            <td>
                                <input mdbCheckbox class="form-check-input" name="row"
                                    style="height: 13px; width: 13px;" type="checkbox" [(ngModel)]="shift.checked"
                                    (change)="toggleRowEnabled(i)" value="" />
                            </td>
                            <td style="display: none;">{{ shift.BranchID }}</td>
                            <td>{{ shift.BranchName }}</td>
                            <td>
                                <div style="width: 150px">
                                    <input name="latitude" placeholder="0" 
                                        class="form-control" type="number" [(ngModel)]="shift.Latitude"
                                        [disabled]="!rowEnabled[i]" (keypress)="ValidateInput($event, 'Latitude')"
                                        (paste)="onPaste($event)" />
                                </div>
                            </td>
                            <td>
                                <div style="width: 150px">
                                    <input name="longitude" placeholder="0" 
                                        class="form-control" type="number" [(ngModel)]="shift.Longitude"
                                        [disabled]="!rowEnabled[i]" (keypress)="ValidateInput($event, 'Latitude')"
                                        (paste)="onPaste($event)" />
                                </div>
                            </td>
                            <td>
                                <div style="width: 150px">
                                    <input name="radius" class="form-control" [(ngModel)]="shift.Radius"
                                        [disabled]="!rowEnabled[i]" type="number" 
                                        (keypress)="ValidateInput($event, 'radius')" min="0"
                                        (paste)="onPaste($event)" />
                                </div>
                            </td>

                            <td style="text-align: center;">
                                <input mdbCheckbox class="form-check-input" name="isaltitudeapplicable{{i}}"
                                    style="height: 13px; width: 13px;" type="checkbox" [disabled]="!rowEnabled[i]" [(ngModel)]="shift.IsAltitudeApplicable"
                                    value="" />
                            </td>
                            
                            <td>
                                <div style="width: 150px">
                                    <input name="altitude" class="form-control" [(ngModel)]="shift.Altitude"
                                        [disabled]="disableAltitude(rowEnabled[i], shift.IsAltitudeApplicable)" type="number"
                                        (keypress)="ValidateInput($event, 'NumandDec')" (paste)="onPaste($event)" />
                                </div>
                            </td>

                            <td>
                                <div style="width: 150px">
                                    <input name="altituderadius" class="form-control" [(ngModel)]="shift.AltitudeRadius"
                                        [disabled]="disableAltitude(rowEnabled[i], shift.IsAltitudeApplicable)" type="number"
                                        (keypress)="ValidateInput($event, 'NumandDec')" (paste)="onPaste($event)" />
                                </div>
                            </td>

                            <td>
                                <div style="width: 150px">
                                    <input name="accuracy" type="number" class="form-control"
                                        [(ngModel)]="shift.Accuracy" [disabled]="!rowEnabled[i]" type="number"
                                        (keypress)="ValidateInput($event, 'NumandDec')"
                                        (paste)="onPaste($event)" />
                                </div>
                            </td>

                            <td>
                                <div style="width: 150px">
                                    <input name="heading" type="number" class="form-control" [(ngModel)]="shift.Heading"
                                        [disabled]="!rowEnabled[i]"
                                        (keypress)="ValidateInput($event, 'NumandDec')" (paste)="onPaste($event)" />
                                </div>
                            </td>
                            
                        </tr>
                    </tbody>
                </table>

            </div>
        </div>
    </div>
    <div class="card-footer">
        <div class="row">
            <div class="col">

                <div class="row">
                </div>
                <div class="row">
                </div>
            </div>
            <div class="col-auto">
                <button *ngIf="this.common.PageRight.IsPrint" class="btn btn-sm btn-primary" name="sample"
                    (click)="exportToExcel()">
                    <i class="bi bi-file-earmark-arrow-down" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Excel':'Loading...'}}
                </button>&nbsp;&nbsp;
                <button class="btn btn-sm btn-primary" name="sample" (click)="downloadExcel()">
                    <i class="bi bi-file-earmark-excel-fill" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Sample':'Loading...'}}
                </button>
                &nbsp;&nbsp;
                <label for="file-upload" class="btn btn-sm btn-primary">
                    <i class="bi bi-cloud-upload-fill" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled ? 'Excel Upload' : 'Loading...'}}
                </label>
                <input id="file-upload" type="file" style="display: none" (change)="handleFileInput($event)"
                    accept=".xls,.xlsx">
                &nbsp;&nbsp;
                <button *ngIf="this.common.PageRight.IsEdit" class="btn btn-sm btn-primary" name="save"
                    (click)="save()">
                    <i class="bi bi-save" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Save':'Loading...'}}
                </button>
            </div>
        </div>
    </div>
</div>